import { CheckCircle } from "@winamp/icons/CheckCircle.js";
import { ExclamationCircle } from "@winamp/icons/ExclamationCircle.js";
import { InfoCircle } from "@winamp/icons/InfoCircle.js";
import { RemoveCircle } from "@winamp/icons/RemoveCircle.js";
import { useContext } from "react";
import type { Iconable } from "../../types";
import { MessageContext } from "./Message";
import type { MessageVariants } from "./variants";

const toastIconsMap: Record<NonNullable<MessageVariants["type"]>, Iconable> = {
  info: InfoCircle,
  neutral: InfoCircle,
  success: CheckCircle,
  error: RemoveCircle,
  warning: ExclamationCircle,
};

export function MessageIcon() {
  const context = useContext(MessageContext) ?? {};
  if (!context) {
    throw new Error("MessageIcon must be used within a Message");
  }

  const Icon = toastIconsMap[context.type];

  return <Icon className="w-5 h-5 shrink-0" />;
}
